import {
    MutationResolvers,
    PresignedS3UrlDocument,
    PresignedS3UrlQuery,
    AssetFromAssetIdDocument,
    AssetFromAssetIdQuery,
} from '../../../../../generated/graphql'

const generateUploadUrl: MutationResolvers['generateUploadUrl'] = async (_root, { assetId }, { client }) => {
    if (!client) {
        throw new Error('Missing ApolloClient')
    }

    const { data: vehicleData } = await client.query<AssetFromAssetIdQuery>({
        query: AssetFromAssetIdDocument,
        variables: { assetId },
    })

    const { accountId } = vehicleData?.auction?.assets?.byId?.consignor || {}

    if (!accountId) {
        throw new Error('Missing consignor accountId')
    }

    console.debug('PresignedS3UrlQuery', accountId)

    const { data: presignedS3Data } = await client.query<PresignedS3UrlQuery>({
        query: PresignedS3UrlDocument,
        variables: { accountId },
        fetchPolicy: 'no-cache',
    })

    console.debug({ presignedS3Data })

    const details = presignedS3Data.auction?.document?.documentUploadURLs?.[0]

    if (!details || !details.s3uploadUrl || !details.s3Key || !details.fileName) {
        throw new Error('Missing s3uploadUrl')
    }

    return details
}

export default generateUploadUrl
